export default __webpack_public_path__ + "static/media/Flag_of_Botswana.d4ed1a48.svg";